module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-11.8ee890ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-11.png
// module id = 191
// module chunks = 0